import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { SETTING_SCROLL_ID } from '.'
import { Element } from '../../common/html/element'
import { Tooltip } from '../../common/tooltip'
import { Z_INDEX } from '../../utils/common'
import { PANEL_EMAIL_SETTING_ID } from './constant'
import { selectOtherSetting } from './createEditProfile/store/slice'
import { selectSettings } from './store/slice'

export const TooltipEmail = ({
  children,
  contentClass,
  contentStyle,
  tooltipSpace,
  isCreateEdit = true,
}) => {
  const setSearchParams = useSearchParams()[1]
  const isEmailActive = useSelector(selectSettings('isAlertEmail'))
  const enableEmails = useSelector(selectOtherSetting('enableEmail'))

  const handleClick = () => {
    //Back to settings screen
    setSearchParams({})

    const scrollDiv = document.querySelector(
      `#${SETTING_SCROLL_ID} .scrollbars div:first-child`,
    )
    const scrollElement = document.getElementById(PANEL_EMAIL_SETTING_ID)

    if (scrollDiv && scrollElement) {
      scrollDiv.scrollTo({
        top: scrollElement.offsetTop,
        behavior: 'smooth',
      })
    }
  }

  return (
    <Tooltip
      tooltipContent={
        <>
          <Translate
            value="alertSetting.DISABLE_EMAIL_TOOLTIP_1"
            dangerousHTML
          />
          &nbsp;
          <Element
            elementName="span"
            className="cursorPointer"
            style={{ color: '#2C73E8' }}
            onClick={handleClick}
          >
            <Translate value="alertSetting.DISABLE_EMAIL_TOOLTIP_2" />
          </Element>
          &nbsp;
          <Translate value="alertSetting.DISABLE_EMAIL_TOOLTIP_3" />
        </>
      }
      contentClass={contentClass}
      contentStyle={contentStyle}
      isInsideContent={true}
      tooltipSpace={tooltipSpace || 6}
      disabled={isEmailActive}
      zIndex={Z_INDEX.MODAL + 1}
    >
      {children(isCreateEdit ? enableEmails && isEmailActive : isEmailActive)}
    </Tooltip>
  )
}
